<template>
	<footer class="footer eng">
		<div class="footer-wrap">
			<div class="footer-privacy">
				<div class="container">
					<router-link to="/ko/privacy-policy">Privacy Policy</router-link>
					<router-link to="/ko/policy">Terms of Service</router-link>
				</div>
			</div>
			<div class="footer-info">
				<div class="container">
					<div class="footer-info-lt">
						<div class="footer-info-logo">
							<ul>
								<li class="footer-info-logo1">
									<i class="icon"></i>
									<span class="sr-only">중소벤처기업부</span>
								</li>
								<li class="footer-info-logo2">
									<i class="icon"></i>
									<span class="sr-only">한국중소벤처기업유통원</span>
								</li>
								<li class="footer-info-logo3">
									<i class="icon"></i>
									<span class="sr-only">소상공인시장진흥공단</span>
								</li>
							</ul>
						</div>
						<div class="footer-info-txt">
							<dl>
								<dt>Inquiries for Participating Companies</dt>
								<dd>02-6678-9882~9889</dd>
							</dl>
							<dl>
								<dt>Available Hours(KST)</dt>
								<dd>Weekdays 10 AM - 5 PM (Lunch Break: 12 PM - 1 PM)</dd>
							</dl>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="quick-btn fcc" id="top_btn2"><a></a></div>
	</footer>
</template>

<script>
import Icon from '@/components/common/Icon';

export default {
	name: 'MainFooter',
	components: { Icon },
	data: () => ({}),
	computed: {},
};
</script>
